export const Text = {
  sizes: {
    'admin-body-lg': {
      fontSize: 'lg',
      lineHeight: 'xl',
    },
    'admin-body-md': {
      fontSize: 'md',
      lineHeight: 'xl',
      letterSpacing: 'wide',
    },
    'admin-body-sm': {
      fontSize: 'sm',
      lineHeight: 'md',
      letterSpacing: 'wide',
    },
    'admin-button-regular': {
      fontSize: 'sm',
      fontWeight: 'semibold',
      lineHeight: 'md',
      letterSpacing: 'wide',
    },
    'admin-button-md': {
      fontSize: 'sm',
      fontWeight: 'medium',
      lineHeight: 'md',
      letterSpacing: 'wide',
    },
    'admin-tag': {
      fontSize: 'xs',
      fontWeight: 'semibold',
      lineHeight: 'xs',
      letterSpacing: 'wider',
    },
    'admin-caption': {
      fontSize: 'xs',
      fontWeight: 'normal',
      lineHeight: 'xs',
      letterSpacing: 'wider',
    },
  },
  defaultProps: { size: 'admin-body-md' },
};
